module.exports = __webpack_public_path__ + "static/media/logo-internal.1de4c238.png";